// window.theme = window.theme || {};
// theme.Blog = (function() {
// 	function init(){
// 		abc();
// 	}
// 	function abc(){

// 	}

// return init; 
// })
jQuery(document).ready(function($) {
	// var sections = new theme.Sections();
 //  	sections.register('blog-template', theme.Blog);
	//	conlole.log("da nhan file js");
  	
/* ---------------------------------------------
Wishlist
 --------------------------------------------- */
function wishlist(){
     // add to wishlist 
  $(document).on('click', '.login_frst' , function(){
     alert("To use this function, please login first");
  })
  $(document).on('click', '.add_to_wishlist' , function(){
  	conlole.log("clicked wishlist ");
    var product_id = $(this).data('id');
    var wl_form = $('.custom_wishlist_form');

    var wl_form_old = wl_form.find('.wishlist-old-data').val();
    var wl_form_new = wl_form.find('.wishlist-data');

    var submit_data = wl_form_old + "," + product_id;
    wl_form_new.val(submit_data);
    wl_form.submit();
  })
  // remove wishlist 
  $(document).on('click', '.remove_from_wishlist' , function(){
    var wl_form = $('.custom_wishlist_form');
    var submit_data = $(this).data('id');
    var wl_form_new = wl_form.find('.wishlist-data');
    wl_form_new.val(submit_data);
    wl_form.submit();
  })
}

});